var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFuel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.797944 0.5C0.356445 0.5 0 0.856442 0 1.29794V12.5H9.92881C10.2644 12.5 10.5871 12.3667 10.8247 12.1291L11.6291 11.3247C11.8667 11.0871 12 10.7644 12 10.4288V0.5H0.797944ZM7.83516 2.04294L3.93202 5.94608C3.83567 6.0424 3.70402 6.09699 3.56756 6.09699C3.36848 6.09699 3.18543 5.98142 3.10034 5.80156L1.58789 2.60489C1.46427 2.3432 1.65532 2.04294 1.94433 2.04294H7.83516ZM1.54294 10.9571V7.15986C1.54294 6.95757 1.70671 6.79379 1.90901 6.79379H5.70617L1.54294 10.9571ZM6.02086 6.09699H4.76369L8.54644 2.31429C8.71981 2.14087 8.95584 2.04294 9.20149 2.04294H10.4586L6.67594 5.82563C6.50257 5.99907 6.26651 6.09699 6.02086 6.09699Z",
    fill: "#00F58C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFuel);
export default __webpack_public_path__ + "static/media/icon-fuel.13aac7e898098ef4f0604f36844d7ace.svg";
export { ForwardRef as ReactComponent };